import React, { useState } from "react";
import axiosInstance from '../../../../_helpers/axiosConfig';
import { authHeader } from '../../../../_helpers/auth-header'
import { Button, Spinner, Modal } from "react-bootstrap";

function handleAddToWaitlist(show, loading, reload, reservationId) {
  axiosInstance.request({
    method: 'POST',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/vaccine/reservation/${reservationId}/keep`,
  }).then((response) => {
    show(false);
    loading(false);
    reload();
  })
    .catch((error) => {
      alert(error.response.data.message);
      loading(false);
    });
}

export default function RemoveActions(props) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const { firstName, lastName, reservationId } = props.data;

  return (
    <div>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add To Waitlist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to add&nbsp;{firstName}
            &nbsp;{lastName}
            &nbsp;to the waitlist?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={loading}
            onClick={() => {
              setLoading(true);
              handleAddToWaitlist(setShowConfirm, setLoading, props.reload, reservationId);
            }}
          >
            {loading ? <Spinner size="sm" animation="border"></Spinner> : "Yes"}
          </Button>
          <Button disabled={loading} onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      <Button
        size="sm"
        variant="outline-primary"
        onClick={() => setShowConfirm(true)}
      >
        Add To Waitlist
      </Button>
    </div>
  );
}
